import { Grid } from "@mui/material";
import classes from "./SignupWithHoda.module.css";
import { useSearchParams } from "react-router-dom";
import { useEffect, useState } from "react";
import Button from "../../../Components/UI/Button/Button";
import useHttpFetch from "../../../hooks/useHttpFetch";

const SignupWithHoda = () => {
  const [code, setCode] = useState("");
  const [hodaRes, setHodaRes] = useState(null);
  const [isNavigating, setIsNavigating] = useState(false);
  const { error, isLoading, sendRequest } = useHttpFetch();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const codeFromQuery = params.get("code");
    console.log("codeFromQuery", codeFromQuery);
    if (codeFromQuery) {
      setCode(codeFromQuery);
    }
  }, []);

  useEffect(() => {
    const getHodaDataFromBack = async () => {
      if (code && code?.length > 0) {
        const result = await sendRequest({
          url: "networkMarketer/hoda/getInfo",
          noMiddleUrl: true,
          method: "POST",
          body: { code },
        });
        if (result.resIsOk && result.resStatus === 200 && result.response) {
          setHodaRes(result.response);
        }
      }
    };

    getHodaDataFromBack();
  }, [code]);

  const hodaClickHandler = async (e) => {
    //  FIRST WAY
    // const result = await sendRequest({
    //   url: "networkMarketer/hoda/redirectToLink",
    //   noMiddleUrl: true,
    //   isRedirectRequest: true,
    // });
    // console.log("result", result);
    // if (result.resIsOk && result.resStatus === 200 && result.response?.message) {
    //   window.location.href = `${result.response.message}`;
    // }
    //  SECOND WAY
    // try {
    //   const response = await fetch(
    //     "https://servercmit.lafarrerr.com:8082/networkMarketer/hoda/redirectToLink",
    //     {
    //       method: "GET",
    //       credentials: "include", // optional: include cookies if needed
    //       redirect: "manual", // <- tells fetch NOT to follow redirect automatically
    //     }
    //   );

    //   // Check if it's a redirect (302, 301, etc.)
    //   if (response.status === 302 || response.status === 301) {
    //     const redirectUrl = response.headers.get("Location");
    //     if (redirectUrl) {
    //       window.location.href = redirectUrl; // manually redirect the browser
    //     } else {
    //       console.warn("Redirect URL missing in response headers");
    //     }
    //   } else {
    //     // Optional: handle normal response
    //     const data = await response.json();
    //     console.log(data);
    //   }
    // } catch (error) {
    //   console.error("Fetch failed:", error);
    // }
    setIsNavigating(true);
    window.location.href = "https://servercmit.lafarrerr.com:8082/networkMarketer/hoda/redirectToLink";
  };
  return (
    // <div>
    //   <p>we are here</p>
    //   {code && <p>Code from query: {code}</p>}
    // </div>
    <Grid container item xs={12} minHeight="100vh" alignItems="center" justifyContent="center">
      {code ? (
        !hodaRes ? (
          <Grid container item xs={12} justifyContent="center">
            {isLoading ? "sending networkMarketer/hoda/getInfo req" : "code received but no hodaRes"}
          </Grid>
        ) : (
          <Grid container item xs={12} justifyContent="center">
            <pre>{JSON.stringify(hodaRes, null, 2)}</pre>
          </Grid>
        )
      ) : (
        <Grid container item xs={12} justifyContent="center">
          <Button
            isLoading={isNavigating}
            largeWidth={true}
            onClick={hodaClickHandler}
            notTranslationalTxt="Click for hoda redirect"
            style="confirm"
          />
        </Grid>
      )}
    </Grid>
  );
};

export default SignupWithHoda;
